import { TextField, TextFieldProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

export interface GeneratorRelayThresholdFieldProps extends Omit<TextFieldProps, 'value'> {
  value?: number | null
}

export default function GeneratorRelayThresholdField({
  value,
  label,
  onChange,
  ...props
}: GeneratorRelayThresholdFieldProps) {
  const { t } = useTranslation('generator')

  return (
    <TextField
      type="number"
      value={value ?? ''}
      label={label ?? `${t('threshold')} (%)`}
      {...props}
      onChange={onChange}
    />
  )
}
